/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>dynamic-form.component.ts</name>
///
/// <description>
/// A component responsible for rendering the details of each individual question based on values in the data-bound question object.
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>28 Dec 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 28Dec16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Component, Input }  from '@angular/core';
import { FormGroup }                 from '@angular/forms';
import { CUIFeatureInterface } from  '../../interfaces/cui-feature.interface';
import { CUIDynamicFormQuestionBase }              from './question-base';
import { CUIDynamicFormQuestionControlService }    from './question-control.service';

@Component({
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [ CUIDynamicFormQuestionControlService ]
})
export class CUIDynamicFormComponent implements CUIFeatureInterface {
  @Input() questions: CUIDynamicFormQuestionBase<any>[] = [];
  form: FormGroup;
  
  constructor(private qcs: CUIDynamicFormQuestionControlService) {  }
  
  //ngOnInit() {
  ngAfterContentInit() {
    this.form = this.qcs.toFormGroup(this.questions);
  }

  getFormContent() {
    //return JSON.stringify(this.form.value);
    return this.form.value;
  }

  public isFormNotValid() {
      return this.form.invalid;
  }

  public isFormClean() {
      return this.form.dirty === false;
  }

  public setFormPristine() {
      this.form.markAsPristine();
  }

  ngOnChanges(changes: any) { 
    this.form = this.qcs.toFormGroup(this.questions);
  };
    //----------------------------------------------------------
    // Implementations of Interface
    //----------------------------------------------------------
    ngOnInit() {}
    //ngOnChanges(changes: any) { };
    ngDoCheck() { };
    //ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };
    ngOnDestroy() { };
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-dynamic-form/dynamic-form.component.ts